// v 1.0
import React from 'react';
import Style from './auth.module.css';

const AUTH = (props) =>{
    return(
        <div className={Style.authForm}>
            <Header text={props.store.header} />
            <div className={Style.container}>
                <AuthForm text={props.store} action={props.actionForm}/>
            </div>
        </div>
    );
}
const Header = (props)=>{
    return <header>{props.text}</header>;
}

const AuthForm = (props) => {
    return (
        <div className={Style.white_list}>
            <div className={Style.tab_content}>
                {props.text.is_err?<ErrDiv text={props.text.err_auth_text} />:null}                
                <div className={Style.request_form__box}>
                    <InputGroup 
                        descr={props.text.field_token_text} 
                        id="token" 
                        name="token" 
                        type="text" 
                        value={props.text.input_token_text}
                        change={props.action.setInputToken}
                    />
					<Submit text={props.text.auth_btn_text} click={props.action.auth} token={props.text.input_token_text}/>
                    <TextLink text={props.text.help_text} link={props.text.help_link} target_link={props.text.help_target}/>
				</div>
			</div>
        </div>
    )
}
const InputGroup = (props) =>{
    return(
        <div className={Style.col_group}>
            <div className={Style.col}>
                <p>{props.descr}</p>
            </div>
            <div className={Style.col}>
                <div>
                    <input value={props.value} type={props.type} id={props.id} name={props.name} className={Style.input} onChange={
                        (obj)=>{
                            props.change(obj.currentTarget.value)
                        }} />                    
                </div>
            </div>
        </div>
    )
}
const Submit = (props)=>{
    let click = ()=>{
        props.click(props.token)
    }
    return(
        <div className={Style.auth_blue_btn} onClick={click}>
            {props.text}
        </div>
    )
}
const TextLink = (props)=>{
    return (
        <div className={Style.text_center}>
            <a href={props.link} target={props.target_link} className={Style.forgot_password}>{props.text}</a>
        </div>
    )
}
const ErrDiv = (props)=>{
    return (
        <div>
            <font className={Style.user_page_error}>{props.text}</font>
        </div>
    )
}
export default AUTH;